import { createTheme, ThemeProvider } from "@mui/material";

// dichiarato il modulo dei pulsanti, definisco un'interfaccia che consentirà
// l'utilizzabilità delle "varianti" di stile all'interno del codice
declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    forcingChecked: true;
    forcingUnchecked: true;
    outlinedError: true;
    containedError: true;
    containedCustom: true;
    outlinedCustom: true;
    outlinedCustomWhite: true;
    containedMedintCustom: true;
    containedCustomDays: true;
    prestazioniToggle: true;
    prestazioniToggleActive: true;
  }
}

declare module "@mui/material/TableCell" {
  interface TableCellPropsVariantOverrides {
    recurringProgramModalTable: true;
  }
}

export default function ThemeWrapper({ children }: any) {
  const generalTheme = createTheme({
    palette: {
      primary: {
        main: "#2E83C4",
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#0000008F",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#0000008F",
            },
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f44336",
              colors: "#f44336",
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": { color: "#0000008F" },
            "&.Mui-error": {
              color: "#f44336", // Colore del label in stato di errore
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#FFF",
            fontWeight: "bold",
            backgroundColor: "#003267",
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            "&.Mui-checked": { color: "#2E83C4" },
          },
        },
      },
      MuiButton: {
        variants: [
          {
            props: { variant: "outlinedError" },
            style: {
              padding: "6px 16px",
              fontSize: "0.875rem",
              lineHeight: 1.75,
              borderRadius: "4px",
              minWidth: "64px",
              boxSizing: "border-box",

              border: "1px solid",
              color: "#D32F2F",
              fontFamily: "Rubik",
              backgroundColor: "inherit !important",
              textTransform: "capitalize",
              fontWeight: "bold",
              "&:hover": {
                border: "1px solid #D32F2F",
                backgroundColor: "#D32F2F !important",
                color: "#FFFFFF !important",
              },
            },
          },
          {
            props: { variant: "containedError" },
            style: {
              backgroundColor: " #D32F2F",
              fontFamily: "Rubik",
              fontWeight: "bold",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "darkred !important",
                color: "#FFFFFF !important",
              },
              "&:disabled": {
                background:
                  "var(--action-disabledBackground, rgba(0, 0, 0, 0.12))",
              },
            },
          },
          {
            props: { variant: "outlinedCustom" },
            style: {
              color: "#024E88",
              border: "1px solid",
              textTransform: "capitalize",
              fontWeight: "bold",
              backgroundColor: "transparent",
              "&:hover": {
                border: "1px solid",
                backgroundColor: "#2E83C4",
                color: "#FFFFFF",
              },
              "&:disabled": {
                background:
                  "var(--action-disabledBackground, rgba(0, 0, 0, 0.12))",
              },
            },
          },
          {
            props: { variant: "outlinedCustomWhite" },
            style: {
              color: "#FFFFFF",
              border: "1px solid",
              textTransform: "capitalize",
              fontFamily: "Rubik",
              fontWeight: "bold",
              backgroundColor: "transparent",
              "&:hover": {
                border: "1px solid",
                backgroundColor: "#2E83C4",
                color: "#FFFFFF",
              },
              "&:disabled": {
                background:
                  "var(--action-disabledBackground, rgba(0, 0, 0, 0.12))",
              },
            },
          },
          {
            props: { variant: "containedCustom" },
            style: {
              backgroundColor: "#2E83C4",
              fontWeight: "bold",
              fontFamily: "Rubik",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#024E88 !important",
                color: "#FFFFFF !important",
              },
              "&:disabled": {
                background:
                  "var(--action-disabledBackground, rgba(0, 0, 0, 0.12))",
              },
            },
          },
          {
            props: { variant: "containedMedintCustom" },
            style: {
              backgroundColor: "rgba(229, 229, 229, 0.30)",
              "&:hover": {
                backgroundColor: "#465e69 !important",
              },
              "&:disabled": {
                opacity: 0.5,
                cursor: "not-allowed",
                backgroundColor: "rgba(229, 229, 229, 0.30)",
                border: "1px solid rgba(204, 204, 204, 0.80)",
                color: "rgba(0, 0, 0, 0.26)",
              },
            },
          },
          {
            props: { variant: "containedCustomDays" },
            style: {
              backgroundColor: "#85b1da",
              fontWeight: "bold",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#024E88 !important",
                color: "#FFFFFF !important",
              },
              "&:disabled": {
                background:
                  "var(--action-disabledBackground, rgba(0, 0, 0, 0.12))",
              },
            },
          },
          {
            props: { variant: "forcingUnchecked" },
            style: {
              textTransform: "capitalize",
              backgroundColor: "#FF8E50",
              color: "black",
              fontWeight: "bold",
              "&:hover": {
                color: "#FFFFFF",
                backgroundColor: "#B64101",
              },
            },
          },
          {
            props: { variant: "forcingChecked" },
            style: {
              backgroundColor: "#DB8251",
              textTransform: "capitalize",
              color: "black",
              fontWeight: "bold",
              "&:hover": {
                color: "#FFFFFF",
                backgroundColor: "#B64101",
              },
            },
          },
          {
            props: { variant: "prestazioniToggle" },
            style: {
              border: "1px solid #546E7A",
              backgroundColor: "transparent",
              color: "inherit",
              textTransform: "capitalize",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "rgba(71,71,71,0.05)",
                borderColor: "#474747",
              },
              "&:disabled": { opacity: 0.5, cursor: "not-allowed" },
            },
          },
          {
            props: { variant: "prestazioniToggleActive" },
            style: {
              border: "1px solid #474747",
              backgroundColor: "#474747",
              color: "#FFFFFF",
              textTransform: "capitalize",
              fontWeight: "bold",
              "& .medintIcons *": {
                fill: "#FFFFFF",
              },
              "&:hover": {
                backgroundColor: "#3a3a3a",
                borderColor: "#3a3a3a",
                color: "#FFFFFF",
                "& .medintIcons *": {
                  fill: "#FFFFFF",
                },
              },
              "&:disabled": {
                opacity: 0.5,
                cursor: "not-allowed",
                backgroundColor: "#474747",
                borderColor: "#474747",
                color: "rgba(255,255,255,0.7)",
              },
            },
          },
        ],
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            "&.MuiButton-outlined": {
              color: "#024E88",
              border: "1px solid",
              textTransform: "capitalize",
              fontWeight: "bold",
              backgroundColor: "transparent",
              "&:hover": {
                border: "1px solid #2E83C4",
                backgroundColor: "#2E83C4",
                color: "#FFFFFF",
              },
              "&:disabled": {
                background:
                  "var(--action-disabledBackground, rgba(0, 0, 0, 0.12))",
              },
            },
            "&.MuiButton-contained": {
              backgroundColor: "#2E83C4",
              fontWeight: "bold",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#024E88 !important",
                color: "#FFFFFF !important",
              },
              "&:disabled": {
                background:
                  "var(--action-disabledBackground, rgba(0, 0, 0, 0.12))",
              },
            },
          },
        },
      },
      MuiCircularProgress: {
        styleOverrides: {
          root: {
            color: "#2E83C4",
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            "&.MuiChip-filled": {
              backgroundColor: "#2E83C4",
              color: "#FFFFFF",
            },
            "&.MuiChip-outlined": {
              backgroundColor: "transparent",
              borderColor: "#2E83C4",
              color: "#2E83C4",
            },
          },
        },
      },
    },
  });

  return <ThemeProvider theme={generalTheme}>{children}</ThemeProvider>;
}
